module.exports = __webpack_public_path__ + "img/full-text-papers.121955da.svg";